export namespace PageReferences {
    export const NEWS_DETAIL = 'AWFNEWS.DETAIL';
    export const NEWS_ARCHIVE = 'AWFNEWS.ARCHIVE';
    export const NEWS_OVERVIEW = 'AWFNEWS.OVERVIEW';
}